import IndexModel from "@/service/v1/sigap/IndexModel";
// import * as CryptoJS from 'crypto-js';
// const ID_TURMAS = "turmas" as string;
// import moment  from 'moment'; 
 
class MatriculaService extends IndexModel { 
     
    protected  url_certificado = ''; 
     
    constructor() {
        super();
        this.url_certificado =  this.url + '/certificado' ;  
        this.url =  this.url + '/Matricula' ;  
    }
 
    public getApiUrl(  ) {
        return this.getAxios().defaults.baseURL + this.url;
    }

    public getApiUrlCertificado(  ) {
        return this.getAxios().defaults.baseURL + this.url_certificado;
    }

    // URL do PDF da Verificação Final de uma disciplina (mesmos dados da rota VerificacaoFinal).
    public getVerificacaoFinalPdfUrl( params: any, token: any ): string {
        const qs = new URLSearchParams();
        Object.keys(params || {}).forEach(k => {
            const v = params[k];
            if (v !== null && v !== undefined && v !== '') qs.append(k, String(v));
        });
        qs.append('token', token);
        return `${this.getApiUrl()}/VerificacaoFinal/Pdf?${qs.toString()}`;
    }

    // URL do PDF dos alunos sem pré-requisito (mesmos dados da rota MatriculaSemPreRequisito).
    public getMatriculaSemPreRequisitoPdfUrl( disciplinaId: any, params: any, token: any ): string {
        const qs = new URLSearchParams();
        Object.keys(params || {}).forEach(k => {
            const v = params[k];
            if (v !== null && v !== undefined && v !== '') qs.append(k, String(v));
        });
        qs.append('token', token);
        return `${this.getApiUrl()}/Disciplina/${disciplinaId}/MatriculaSemPreRequisito/Pdf?${qs.toString()}`;
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public getAll( search:any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '?' + search    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    
    public getAllWithUsuario( search:any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/WithUsuario?' + search    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    public getAllFromAula(id) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/Aula/' + id )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }


    
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    

    
    public getAprovacaoStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetAprovacaoStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    
    public getUnidadesEscolar( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetUnidadesEscolar'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    
    public cadastrarArquivo(   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/Lote'   , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }

    
    public alterarSimples( id , dados  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/Simples'  , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  

    
    public alterarFormatura( id , dados  ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/Formatura'  , dados  )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }



    public verificarSituacaoMatricula( id   ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/VerificarSituacaoMatricula'  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }


    
    public verificarSituacaoMatriculaLote( turmaId: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().patch( this.url + '/VerificarSituacaoMatricula?turmaId=' + turmaId   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }




    
    public getQuantidadeFaltaLote( id , inicio , fim  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + "/inserir/falta/lote?data_inicio=" + inicio + '&data_fim=' + fim     )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public inserirFaltasLote( id ,  dados ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().post( this.url + '/' + id  + '/inserir/falta/lote'  , dados )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public getAcoes( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().post( this.url + '/' + id  + '/acoes'  , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public AlterarAluno( id , dados  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/Status'  , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
}
  
export default MatriculaService; 